<template>
  <el-dialog title="下推生产" :visible.sync="visible" width="900px" :close-on-click-modal="false" append-to-body>
    <el-form label-width="100px">
      <el-form-item label="下推方式">
        <el-radio-group v-model="mergeMode" :disabled="submitting">
          <el-radio label="single">不合并（每行一张工单）</el-radio>
          <el-radio label="merge">合并（同物料多行一张工单）</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="BOM版本">
        <el-select v-model="bomVersion" clearable filterable placeholder="不选则下达时取当前生效版" style="width:220px" :disabled="submitting || !bomVersionOptions.length">
          <el-option v-for="v in bomVersionOptions" :key="v" :label="v" :value="v" />
        </el-select>
        <span v-if="!bomVersionOptions.length" style="margin-left:8px;color:#909399;font-size:12px">请先勾选明细（同物料）</span>
      </el-form-item>
    </el-form>
    <el-table ref="lineTable" :data="lines" border :header-cell-style="{ background: '#f5f7fa', color: '#606266' }" @selection-change="onSelectionChange">
      <el-table-column type="selection" width="45" header-align="center" align="center" />
      <el-table-column prop="materialCode" label="物料编码" min-width="120" header-align="center" align="left" />
      <el-table-column prop="materialName" label="物料名称" min-width="140" header-align="center" align="left" show-overflow-tooltip />
      <el-table-column prop="quantity" label="订单数量" width="100" header-align="center" align="left" />
      <el-table-column prop="remainProductionQty" label="可生产量" width="100" header-align="center" align="left" />
      <el-table-column label="本次生产" width="180" header-align="center" align="left">
        <template slot-scope="scope">
          <el-input-number
            v-model="scope.row.pushQty"
            :min="0"
            :max="Number(scope.row.remainProductionQty || 0)"
            :precision="2"
            size="small"
            style="width:100%"
          />
        </template>
      </el-table-column>
    </el-table>
    <span slot="footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" :loading="submitting" @click="submit">下推</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { getLinesForProduction, pushFromSales, listMaterialBomVersion } from '../../api/production/productionOrder'

export default {
  name: 'ProductionPushFromSales',
  data() {
    return {
      visible: false,
      submitting: false,
      salesOrderId: '',
      mergeMode: 'single',
      bomVersion: '',
      bomVersionOptions: [],
      lines: [],
      selected: []
    }
  },
  methods: {
    init(salesOrderId) {
      this.visible = true
      this.salesOrderId = salesOrderId
      this.mergeMode = 'single'
      this.bomVersion = ''
      this.bomVersionOptions = []
      this.selected = []
      getLinesForProduction(salesOrderId).then(res => {
        const list = Array.isArray(res.data) ? res.data : ((res.data && res.data.list) || [])
        this.lines = (list || []).map(l => ({
          ...l,
          pushQty: Number(l.remainProductionQty || 0)
        }))
        if (!this.lines.length) this.$message.warning('该销售订单没有可下推生产的明细')
      }).catch(() => { this.lines = [] })
    },
    onSelectionChange(rows) {
      this.selected = rows || []
      this.loadBomVersions()
    },
    loadBomVersions() {
      if (!this.selected.length) {
        this.bomVersionOptions = []
        this.bomVersion = ''
        return
      }
      const mid = this.selected[0].materialId
      if (this.mergeMode === 'merge' && this.selected.some(r => r.materialId !== mid)) {
        this.bomVersionOptions = []
        return
      }
      listMaterialBomVersion(mid).then(res => {
        this.bomVersionOptions = res.data || []
        if (this.bomVersion && !this.bomVersionOptions.includes(this.bomVersion)) this.bomVersion = ''
      }).catch(() => { this.bomVersionOptions = [] })
    },
    submit() {
      if (!this.selected.length) {
        this.$message.warning('请勾选销售明细')
        return
      }
      if (this.mergeMode === 'merge') {
        const mid = this.selected[0].materialId
        if (this.selected.some(r => r.materialId !== mid)) {
          this.$message.warning('合并生产须为同一物料')
          return
        }
      }
      const payloadLines = []
      for (const row of this.selected) {
        const qty = Number(row.pushQty || 0)
        if (qty <= 0) {
          this.$message.warning('本次生产数量必须大于0')
          return
        }
        payloadLines.push({ salesOrderLineId: row.salesOrderLineId, quantity: qty })
      }
      this.submitting = true
      const payload = { mergeMode: this.mergeMode, lines: payloadLines }
      if (this.bomVersion) payload.bomVersion = this.bomVersion
      pushFromSales(payload).then(res => {
        this.submitting = false
        const ids = (res.data && res.data.productionOrderIds) || (res.data && res.data.list) || res.data || []
        const n = Array.isArray(ids) ? ids.length : 0
        this.$message.success('已生成 ' + n + ' 张生产工单')
        this.visible = false
        this.$emit('success')
      }).catch(() => { this.submitting = false })
    }
  },
  watch: {
    mergeMode() { this.loadBomVersions() }
  }
}
</script>
